package com.exura.features.userprofile.domain.model

import com.exura.features.newauth.domain.model.ProviderUserRole
import dev.gitlive.firebase.firestore.CollectionReference

data class DoctorProfile(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val email: String,
    val fullName: String?,
    val specialization: String?,
) : ProviderProfile(
    firebaseDocId = firebaseDocId,
    firebaseDocPrefix = firebaseDocPrefix,
    providerRole = ProviderUserRole.DOCTOR,
) {
    override fun makeStamp(): Stamp = Stamp(
        signature = if (fullName != null) {
            if (specialization != null) {
                "$fullName\n$specialization"
            } else {
                fullName
            }
        } else {
            null
        },  // list -> filter -> join ?
        contact = null,
    )
}
